import {
  AppleLogo,
  ClueLogo,
  FloLogo,
  GoogleHealthConnectLogo,
  NaturalCyclesLogo,
} from '@jouzen/ecom-components';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

export const integrations: LandingPageIntegrationData[] = [
  {
    description: 'womens_integrations_nc_copy',
    Logo: NaturalCyclesLogo,
    name: 'Natural Cycles',
  },
  {
    description: 'womens_integrations_clue_copy',
    Logo: ClueLogo,
    name: 'Clue',
  },
  {
    description: 'womens_integrations_flo_copy',
    Logo: FloLogo,
    name: 'Flo',
  },
  {
    description: 'womens_integrations_apple_health_copy',
    Logo: AppleLogo,
    name: 'Apple Health Kit',
  },
  {
    description: 'womens_integrations_health_connect_copy',
    Logo: GoogleHealthConnectLogo,
    name: 'Google Health Connect',
  },
];
